<template>
    <div >
        <Card>
            <p slot="title"> Chart of Account (COA) </p>
            <Button
                v-show="canCreateCOA()"
                type="primary"
                slot="extra"
                @click="modal.createCOA=true"
                size="small"  >
                Tambah
            </Button>
            <template>
                <Table border :columns="columnTableCOA" :data="dataCOA"></Table>
            </template>
        </Card>

        <!-- Modal Add -->
        <Modal v-model="modal.createCOA" width="500px">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Tambah Chart of Account (COA)</span>
            </p>
            <Form ref="formCOA" :model="formCOA" :rules="ruleValidate">
                <Form-item label="Code" prop="code">
                    <Input v-model="formCOA.code" placeholder="Code"></Input>
                </Form-item>

                <Form-item label="Account Name" prop="accountName">
                    <Input v-model="formCOA.accountName" placeholder="Account Name"></Input>
                </Form-item>

                <Form-item label="Bank Account">
                    <Select
                        v-model="formEditCOA.bankAccountId"
                        filterable>
                        <Option v-for="(option, index) in listBankAccount"
                            :value="option.id" :key="index">{{option.accountName}}</Option>
                    </Select>
                </Form-item>
            </Form>
            <div slot="footer">
                <Button
                    v-show="true"
                    type="primary"
                    :loading="loadingCreateCOA"
                    @click="postCreateCOA" >
                    <span v-if="!loadingCreateCOA">Simpan</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
        </Modal>

        <!-- Modal Edit -->
        <Modal v-model="modal.editCOA" width="500px">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Edit Chart of Account (COA)</span>
            </p>
            <Form ref="formEditCOA" :model="formEditCOA" :rules="ruleValidate">
                <Form-item label="Code" prop="code">
                    <Input style="display: none;" v-model="formEditCOA.id"></Input>
                    <Input v-model="formEditCOA.code" placeholder="Code"></Input>
                </Form-item>

                <Form-item label="Account Name" prop="accountName">
                    <Input v-model="formEditCOA.accountName" placeholder="Account Name"></Input>
                </Form-item>

                <Form-item label="Bank Account">
                    <Select
                        v-model="formEditCOA.bankAccountId"
                        filterable>
                        <Option v-for="(option, index) in listBankAccount"
                            :value="option.id" :key="index">{{option.accountName}}</Option>
                    </Select>
                </Form-item>
            </Form>
            <div slot="footer">
                <Button
                    v-show="true"
                    type="primary"
                    :loading="loadingEditCOA"
                    @click="postEditCOA" >
                    <span v-if="!loadingEditCOA">Edit</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import { HTTP } from '@/components/http-lib'
    import _ from 'lodash'

    export default {
        data () {
            return {
                user : {
                    username : '',
                    role : ''
                },
                modal : {
                    createCOA : false,
                    editCOA : false
                } ,
                formCOA: {
                    code: '',
                    accountName: '',
                    bankAccountId: ''
                },
                formEditCOA: {
                    id: '',
                    code: '',
                    accountName: '',
                    bankAccountId: ''
                },
                ruleValidate: {
                    code: [
                        { required: true, message: 'Code is required', trigger: 'blur' }
                    ],
                    accountName: [
                        { required: true, message: 'Account name is required', trigger: 'blur' }
                    ],
                    bankAccountId: [
                        { required: true, message: 'Bank account is required', trigger: 'blur' }
                    ],
                },
                loadingSearch: false,
                listBankAccount: [],
                loadingCreateCOA: false,
                loadingEditCOA: false,
                dataCOA : [],
                columnTableCOA: [
                    {
                        title: 'Code',
                        key: 'code',
                    },
                    {
                        title: 'Account Name',
                        key: 'accountName',
                    },
                    {
                        title: 'Bank Account',
                        key: 'bankAccountName',
                    },
                    {
                        title: 'Action',
                        key: 'action',
                        width: 120,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'success',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.show(params.index)
                                        }
                                    }
                                }, 'Edit')
                            ]);
                        }
                    }
                ],
            }
        },
        methods: {
            canCreateCOA () {
                let canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR'], this.user.role);
                return canAccess;
            },
            getBankAccount: function() {
                HTTP.get("bankAccount/findAll/active")
                .then(response => {
                    this.listBankAccount = response.data;
                })
                .catch(e => {
                    this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                    });
                });
            },
            getCOA: function(){
                HTTP
                .get('coa')
                .then(response => {
                    console.log({response});
                    let dataCOATemp = []

                    _.forEach(response.data, function(value, index) {
                        let dataCOAMapping = {
                            id : value.id,
                            code : value.code,
                            accountName : value.account_name,
                            bankAccountId : value.bank_account ? value.bank_account.id : '',
                            bankAccountName : value.bank_account ? value.bank_account.accountName : '',
                        }

                        dataCOATemp.push(dataCOAMapping);
                    });

                    this.dataCOA = dataCOATemp;
                })
                .catch(e => {
                    console.log({e});
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            },
            postCreateCOA:function(){
                this.loadingCreateCOA = true;

                let codeExist = _.some(this.dataCOA, {code: this.formCOA.code });
                let accountNameExist = _.some(this.dataCOA, {accountName: this.formCOA.accountName });

                if(codeExist || accountNameExist){
                    this.$Message.error('Account name or code is exist');
                    this.loadingCreateCOA = false;
                    return false;
                }

                let payload = {
                    code: this.formCOA.code,
                    accountName: this.formCOA.accountName,
                    bankAccountId: this.formCOA.bankAccountId
                }

                HTTP
                .post('coa/create', payload)
                .then(response => {
                    this.loadingCreateCOA = false;
                    this.modal.createCOA = false;
                    this.formCOA.code = '';
                    this.formCOA.accountName = '';
                    this.formCOA.bankAccountId = '';

                    this.$Message.success('Chart of Account has been created');
                    this.getCOA();
                })
                .catch(e => {
                    this.loadingCreateCOA = false;
                    this.$Notice.error({
                        title: "Error",
                        desc:e,
                        duration: 5
                    });
                })
            },
            show: function(index){
                console.log(this.dataCOA[index]);
                this.formEditCOA.id = this.dataCOA[index].id;
                this.formEditCOA.code = this.dataCOA[index].code;
                this.formEditCOA.accountName = this.dataCOA[index].accountName;
                this.formEditCOA.bankAccountId = this.dataCOA[index].bankAccountId;

                // for validate when postEdit
                this.formEditCOA.codeTemp = this.dataCOA[index].code;
                this.formEditCOA.accountNameTemp = this.dataCOA[index].accountName;

                this.modal.editCOA = true;
            },
            postEditCOA:function(){
                this.loadingEditCOA = true;

                let codeExist = _.some(this.dataCOA, {code: this.formEditCOA.code });
                let accountNameExist = _.some(this.dataCOA, {accountName: this.formEditCOA.accountName });

                if((codeExist || accountNameExist) && (this.formEditCOA.code != this.formEditCOA.codeTemp || this.formEditCOA.accountName != this.formEditCOA.accountNameTemp)){
                    this.$Message.error('Account name or code is exist');
                    this.loadingCreateCOA = false;
                    return false;
                }

                let payload = {
                    id: this.formEditCOA.id,
                    code: this.formEditCOA.code,
                    accountName: this.formEditCOA.accountName,
                    bankAccountId: this.formEditCOA.bankAccountId
                }

                console.log({payload});

                HTTP
                .post('coa/update', payload)
                .then(response => {
                    this.loadingEditCOA = false;
                    this.modal.editCOA = false;
                    this.formEditCOA.code = '';
                    this.formEditCOA.accountName = '';
                    this.formEditCOA.bankAccountId = '';

                    this.$Message.success('Chart of Account has been changed');
                    this.getCOA();
                })
                .catch(e => {
                    this.loadingEditCOA = false;
                    this.$Notice.error({
                        title: "Error",
                        desc:e,
                        duration: 5
                    });
                })
            }
        },
        created() {
            this.user.role = localStorage.getItem('user.role');
            this.getCOA();
            this.getBankAccount();
        }
    }
</script>



// WEBPACK FOOTER //
// Coa.vue?05d46beb